import { ShortCode } from '@highereducation/wordpress';
import { Card, type CardProps } from '@highereducation/hen-ui';

type CardShortcodeProps = Pick<
  CardProps,
  'variant' | 'border' | 'padding' | 'rounded'
> & {
  children?: React.ReactNode;
};

/**
 * CardShortcode - Shortcode wrapper for the Card composite.
 *
 * Supported shortcode attributes:
 * - variant: `background-white` | `background-gray` | `background-secondary` | `background-transparent`
 * - border: `none` | `padding` | `stroke` | `strokeLight` | `strokeSecondary` | `strokeError` | `strokeSuccess` | `shadow`
 * - padding: `none` | `lg` | `section` — spacing on the card root, independent of `border`.
 *   `section` is the responsive section spacing (peaks at 40px at desktop). When the card wraps
 *   `[hen-ui-card-content]`, set `content-padding="none"` on the content so the two don't stack.
 * - rounded: `md` (10px) | `lg` (20px) | `xl` (32px) — corner radius. Default `lg`.
 */
export const CardShortcode: ShortCode<CardShortcodeProps> = {
  balanced: true,
  component: ({
    variant = 'background-white',
    border = 'none',
    padding,
    rounded,
    children,
  }) => {
    return (
      <Card
        variant={variant}
        border={border}
        padding={padding}
        rounded={rounded}
      >
        {children}
      </Card>
    );
  },
};
